/* Skinny Genie redesign: Café Menu page behaviour.
   Loaded by sections/page-cafe-top.liquid. The only scripted piece on this
   page is the Café Signatures row, which becomes a swipeable carousel with
   arrow buttons below 700px. The category tab bar is plain anchor links, as
   in the mockup, so it needs no script. */
(function () {
  'use strict';

  function track() { return document.getElementById('cafe-sig-track'); }

  function scrollSignatures(dir) {
    var t = track();
    if (!t) return;
    var card = t.querySelector('.bs-card');
    var step = card ? card.getBoundingClientRect().width + 16 : 300;
    t.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function updateArrows() {
    var t = track();
    var prev = document.getElementById('cafe-sig-prev');
    var next = document.getElementById('cafe-sig-next');
    if (!t || !prev || !next) return;
    prev.classList.toggle('disabled', t.scrollLeft <= 4);
    next.classList.toggle('disabled', t.scrollLeft + t.clientWidth >= t.scrollWidth - 4);
  }

  function init() {
    var t = track();
    if (!t) return;

    var prev = document.getElementById('cafe-sig-prev');
    var next = document.getElementById('cafe-sig-next');
    if (prev) prev.addEventListener('click', function () { scrollSignatures(-1); });
    if (next) next.addEventListener('click', function () { scrollSignatures(1); });

    t.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* The card images load lazily, so the track's scrollWidth is not final at
       DOMContentLoaded and the "next" arrow can start out wrongly disabled. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateArrows);
    window.addEventListener('load', updateArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Category tab bar: underline the section in view and scroll to a section
   just below the sticky bar, the same behaviour as .page-subnav in
   skinny-genie-wholesale.js (added 2026-09-30). */
(function () {
  function initTabs() {
    var nav = document.querySelector('.cafe-tabs');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var sections = links.map(function (link) {
      return document.getElementById(link.getAttribute('href').slice(1));
    }).filter(Boolean);

    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle('active', link.getAttribute('href') === '#' + id);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      sections.forEach(function (section) { observer.observe(section); });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - (nav.offsetHeight + 12);
        window.scrollTo({ top: top, behavior: 'smooth' });
        setActive(target.id);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
})();
